import React from "react"

import { Row, Col, Button } from 'antd'

import noDataImg from '../assets/images/icon_order_no_data.png'
import cancelImg from '../assets/images/icon-icon-cancel-30@3x.png'

export default function PartyPopUp(props) {
    const { popUpState, setPopUpState } = props

    const handleClose = () => {
        setPopUpState(!popUpState)
    }

    return (
        <Row
            type="flex"
            justify="center"
            align="middle"
            className={popUpState ? "party-login-popup-frame" : "web-hidden"}
        >
            <Col className="party-login-popup-content-frame">
                <Row type="flex" justify="center">
                    <img src={noDataImg} className="party-login-popup-nodata-img" alt="no data" />
                </Row>

                <p>你尚未報名此競賽</p>
                <p>若有錯誤，請與主辦單位聯繫</p>

                <Button className="party-login-popup-close-btn" onClick={() => handleClose()}>
                    關閉                    
                </Button>

                <button className="party-login-popup-close-icon" onClick={() => handleClose()}>
                    <img src={cancelImg} className="web-img" alt="cancel" />
                </button>

            </Col>
        </Row>
    )
}